export class KRAMeasurementTypeData {
    Id: number;
    MeasurementType: string;
}